import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { getIntl } from '../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import { ProfileMessageInput, useProfileMessagingState } from '../../../../shared/ProfileMessaging';

const intl = getIntl('sendClientsMessageScreen', {
    message: 'Message',
    send: 'Send',
    cancel: 'Cancel',
});

export type SendClientsMessageScreenOwnProps = {};

export type SendClientsMessageScreenProps = SendClientsMessageScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'send-clients-message'>;
};

const SendClientsMessageScreen: React.FC<SendClientsMessageScreenProps> = ({
    route: {
        params: { clientMedicalProfileIds },
    },
}) => {
    const goBack = useGoBack();
    const { onSend, isSendDisabled, message, setMessage, onCancel } = useProfileMessagingState({
        onCancel: goBack,
        onClose: goBack,
        selectedProfileIds: clientMedicalProfileIds,
    });
    return (
        <ActionButtonLayout
            whiteBackground
            actions={[
                {
                    title: intl('cancel'),
                    icon: 'X',
                    onPress: onCancel,
                    variant: 'secondary',
                    testID: 'cancel-add-message',
                },
                {
                    title: intl('send'),
                    icon: 'Send',
                    onPress: onSend,
                    isDisabled: isSendDisabled,
                    testID: 'submit-add-message',
                },
            ]}
        >
            <MainContentContainer flex={1} testID="add-message-screen-root">
                <ProfileMessageInput
                    selectedProfileIds={clientMedicalProfileIds}
                    message={message}
                    setMessage={setMessage}
                    type="client-profiles"
                />
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(SendClientsMessageScreen);
